<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="message" :class="[...messageClass, ...themeClasses]">
    <div v-if="source.showTime" class="time">{{ formatTime() }}</div>
    <div class="message-item">
      <van-image
        class="message-avatar"
        round
        width="0.72rem"
        height="0.72rem"
        :src="isUserMsg ? userAvatar : defaultAvatar"
      />
      <div v-if="source.type === 1" class="bubble" :class="bubbleClass">
        <div v-for="(text, index) in texts" :key="index">
          <span v-if="text" v-html="text"></span>
          <br v-else />
        </div>
      </div>
      <div v-else-if="source.type === 7" class="bubble" :class="bubbleClass">
        <div>
          <div>
            {{ formContent.text }}
          </div>
          <button class="message-btn" @click="onClickUploadDrafts()">
            {{ formContent.btnText }}
          </button>
        </div>
      </div>
      <div v-else-if="source.type === 4" class="bubble text-list">
        <div class="question-box">
          <div
            v-for="(item, index) in textList"
            :key="item"
            class="question"
            @click="onSendQuestion(item)"
          >
            <span>{{ index + 1 }}.{{ item }}</span>
          </div>
        </div>
      </div>
      <!-- 这里的类型不是真实type，只是为了配置type=4的特殊情况需要样式的虚拟类型 -->
      <div
        v-if="source.type === 4.1 && source.showHelp"
        class="bubble left text-left help"
        :class="{ 'can-click': !clickedNoHelp }"
        @click="onClickHelp"
      >
        上述没有我想要的问题
      </div>
      <!-- 意见反馈 -->
      <Card v-else-if="source.type === 5" />
      <!-- 图片 -->
      <div
        v-else-if="source.type === 2"
        class="bubble image-box"
        :style="imageBoxStyle"
        @click="onViewImage"
      >
        <img :src="source.content" :style="imageStyle" />
      </div>
      <!-- 视频 -->
      <div
        v-else-if="source.type === 3"
        ref="videoImg"
        class="bubble video-box"
        :style="videoBoxStyle"
        @click="onClickVideo"
      >
        <van-loading
          v-if="!posterStatus"
          style="
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
          "
        >
        </van-loading>
        <template v-else-if="posterStatus === 1">
          <!-- h5 video 有兼容问题，ios封面也加载出不来，这个不是用video标签 -->
          <img
            :style="{ width: `${videoSize.w}px`, height: `${videoSize.h}px` }"
            :src="poster"
          />
          <img class="play-icon" src="@/assets/img/feedback/play.png" />
        </template>
        <div style="z-index: inherit" class="poster" v-else>
          <span
            style="
              color: #fff;
              position: absolute;
              left: 0.5em;
              bottom: 0.5em;
              font-size: 0.16rem;
            "
            >{{ computedVideoDuration }}</span
          >
          <img class="play-icon" src="@/assets/img/feedback/play.png" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import EventBus from '@/utils/event-bus'
import { rem2px } from '@/utils/formatter'
import { Image as VanImage } from 'vant'
import { m2uBridge } from '@/utils/m2u-bridge'
import { durationToSecond } from './format'

import Card from './card'
dayjs.extend(isSameOrAfter)

export default {
  name: 'Message',
  components: {
    Card,
    VanImage,
  },
  props: {
    source: {
      type: Object, // 1.文本 2.图片 3.视频 4.段落列表 5.反馈卡片 6. 7.按钮打开新页面
      required: true,
    },
    noHelpedList: {
      type: Array,
      default: () => [],
    },
    theme: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      poster: '',
      isPlaying: false,
      playCount: 0,
      formContent: {
        text: '',
        btnText: '',
        btnUrl: '',
      },
      posterStatus: 0,
      videoDuration: 0,
      /** 用户头像 */
      userAvatar: ``,
      defaultAvatar: `https://p4-ky.wsukwai.com/udata/pkg/kmovie/common-figma-plugin/4cb5c980-4112-4850-a2b0-d7bea0512a2d.png`,
    }
  },
  computed: {
    isUserMsg() {
      // source 1用户 2自动回复 3客服回复
      return this.source.source === 1
    },
    messageClass() {
      const arr = []
      arr.push(this.isUserMsg ? 'right' : 'left')
      return arr
    },
    bubbleClass() {
      const arr = []
      if (this.source.type === 1) {
        arr.push(this.isUserMsg ? 'text-right' : 'text-left')
      }
      if (this.source.type === 7) {
        arr.push(this.isUserMsg ? 'text-right' : 'text-left')
      }
      return arr
    },
    texts() {
      if (this.source.type === 1) {
        const { content = '' } = this.source
        return content.split('\n').map((item) => this.strToLink(item))
      }
      return []
    },
    textList() {
      if (this.source.type === 4) {
        return this.source.content.split(';')
      }
      return []
    },
    imageSize() {
      let extra = this.source.extra
      try {
        extra = JSON.parse(extra)
      } catch (e) {
        extra = {}
      }
      const baseW = rem2px(1.6)
      const baseHorizontalW = rem2px(3.46)
      const minW = rem2px(0.6)
      const width = extra.w || baseW
      const height = extra.h || baseW
      if (height >= width) {
        const w = width < baseW ? Math.max(width, minW) : baseW
        const h = (height / width) * w
        return { w, h, boxW: w, boxH: h }
      }
      const w =
        width < baseHorizontalW ? Math.max(width, minW) : baseHorizontalW
      const h = (height / width) * w
      return { w, h, boxW: w, boxH: h }
    },
    imageStyle() {
      const { w, h } = this.imageSize
      return { width: `${w}px`, height: `${h}px` }
    },
    imageBoxStyle() {
      const { boxW, boxH } = this.imageSize
      return { width: `${boxW + 2}px`, height: `${boxH + 2}px` }
    },
    videoSize() {
      let extra = this.source.extra
      try {
        extra = JSON.parse(extra)
      } catch (e) {
        extra = {}
      }
      const baseW = rem2px(3.5)
      const width = extra.w || baseW
      const height = extra.h || baseW * 1.5
      const h = (height / width) * baseW
      return { w: baseW, h }
    },
    videoBoxStyle() {
      const { w, h } = this.videoSize
      return { width: `${w + 2}px`, height: `${h + 2}px` }
    },
    videoType() {
      let suffix = 'mp4'
      const { type, content } = this.source
      if (type === 3) {
        const matched = content.match(/\.(\w+)?$/)
        if (matched) {
          suffix = matched[1]
        }
      }
      if (suffix === 'quicktime') {
        suffix = 'mp4'
      }
      return `video/${suffix}`
    },
    clickedNoHelp() {
      return (
        this.noHelpedList.includes(this.source.id) || this.source.help === 2
      )
    },
    themeClasses() {
      const themes = Array.isArray(this.theme) ? this.theme : [this.theme]
      return themes.map((th) => `theme-${th}`)
    },
    computedVideoDuration() {
      return durationToSecond((this.videoDuration ?? 0) * 1000)
    },
  },
  mounted() {
    this.getAvatar()
    this.setPoster()
  },
  methods: {
    getAvatar() {
      this.userAvatar = this.defaultAvatar // 设置默认头像
      m2uBridge
        .getLoginStatus()
        .then((res) => {
          const data = res?.data
          this.userAvatar =
            data?.head_url ?? data?.headUrl ?? this.defaultAvatar // android 和 ios 字段不一样，已灰度，前端兼容下
        })
        .catch((_) => _)
    },
    messageBtn() {
      if (this.source.type === 7) {
        this.formContent = JSON.parse(this.source.content)
      }
    },
    onClickVideo() {
      // 使用RN页面播放视频，不使用h5 video播放，是因为有的安卓手机全屏闪退，有兼容问题
      const url = `m2u://krn?bundleId=YtFeedback&componentName=rn-video&autoplay=true&source=${this.source.content}`
      m2uBridge.loadUrlOnNewPage(url)
    },
    formatTime() {
      const ts = this.source.createTime
      const now = dayjs().format('YYYY-MM-DD')
      const tsDate = dayjs(ts).format('YYYY-MM-DD')
      if (dayjs(tsDate).isSameOrAfter(now)) {
        return dayjs(ts).format('HH:mm')
      }
      return dayjs(ts).format('YYYY-MM-DD HH:mm')
    },
    onSendQuestion(item) {
      EventBus.$emit('send-question', item)
    },
    onViewImage() {
      EventBus.$emit('view-image', this.source)
    },
    onClickHelp() {
      if (!this.clickedNoHelp) {
        EventBus.$emit('no-help', this.source)
      }
    },
    onClickUploadDrafts() {
      window.open(this.formContent.btnUrl)
    },
    strToLink(preStr) {
      const chineseReg =
        /[\u4E00-\u9FFF]|[\u3400-\u4DBF]|[\u{20000}-\u{2A6DF}]|[\u{2A700}-\u{2B73F}]|[\u{2B740}-\u{2B81F}]|[\u{2B820}-\u{2CEAF}]|[\uF900-\uFAFF]|[\u3300-\u33FF]|[\uFE30-\uFE4F]|[\uF900-\uFAFF]|[\u{2F800}-\u{2FA1F}]/gu
      const spaceStr = preStr.replace(chineseReg, function (a) {
        return ' ' + a + ' '
      })
      const reg = /(((https?:\/\/)|(www\.))[^\s]+)/g
      const str = spaceStr.replace(reg, function (a) {
        const href = a.startsWith('http') ? '' : 'https://'
        return '<<<a target="__blank" href="' + href + a + '">' + a + '</a><<'
      })
      const strArr = str.split('<<')
      const newStr = strArr
        .map((item) => {
          if (item.startsWith('<')) {
            return item
          }

          return item.replace(/\s/g, '')
        })
        .join('')
      return newStr
    },
    setPoster() {
      if (this.source.type !== 3) return
      this.posterStatus = 0
      this.getPosterFromVideo({
        width: this.videoSize.w,
        height: this.videoSize.h,
        src: this.source.content,
      })
        .then((url) => {
          this.poster = url
          this.posterStatus = 1
        })
        .catch((e) => {
          this.posterStatus = 2
          console.log(e)
        })
    },
    /** 从视频中提取封面 */
    getPosterFromVideo({ width = 0, height = 0, src, video }) {
      return new Promise((resolve, reject) => {
        const video = document.createElement('video')
        video.setAttribute('crossOrigin', 'anonymous')
        video.setAttribute('muted', 'muted') // 静音操作，防止播放失败
        video.setAttribute('preload', 'auto')
        video.setAttribute('width', width)
        video.setAttribute('width', height)
        video.setAttribute('autoplay', true)
        video.setAttribute('x5-video-player-type', 'h5')
        video.setAttribute('x5-video-player-fullscreen', true)
        video.setAttribute('playsinline', true)
        video.setAttribute('webkit-playsinline', true)
        video.setAttribute('src', src)
        video.onloadedmetadata = () => {
          video.oncanplaythrough = () => {
            const duration = video.duration
            try {
              video.currentTime = 1
              const canvas = document.createElement('canvas')
              canvas.width = width
              canvas.height = height
              canvas
                .getContext('2d')
                .drawImage(video, 0, 0, canvas.width, canvas.height)
              const imgUrl = canvas.toDataURL('image/png')
              video.currentTime = 0
              video.setAttribute('autoplay', false)
              video.pause()
              resolve(imgUrl)
              throw new Error()
            } catch {
              this.videoDuration = duration
              reject()
            }
          }
        }
        video.onerror = reject
      })
    },
  },
}
</script>
<style lang="less" scoped>
.message {
  display: flex;
  flex-direction: column;
  font-size: 0.28rem;

  @avatarGap: 0.12rem;

  @content-width: calc(100% - 2 * (@avatarGap + 0.64rem));

  .message-item {
    display: flex;
    align-items: flex-start;
    flex-direction: row;
    // gap: @avatarGap; // gap有兼容问题，使用margin代替
    width: 100%;
    padding-top: 0.32rem;

    .left& > .bubble {
      margin-left: @avatarGap;
    }
    .right& > .bubble {
      margin-right: @avatarGap;
    }

    .right& {
      flex-direction: row-reverse;
    }
  }

  .bubble {
    border-radius: 0.16rem;
    overflow: hidden;
    word-break: break-all;
    box-sizing: border-box;
    max-width: @content-width;

    &.text-left {
      padding: 0.2rem;
      background-color: #222;
      color: rgba(255, 255, 255, 0.9);
      border-top-left-radius: 0.1rem;

      .theme-white& {
        background-color: #fff;
        color: #4a505c;
        border-radius: 0.16rem;
      }
    }

    .message-btn {
      background: #ff79b5;
      border-radius: 0.5rem;
      border: 0;
      height: 0.6rem;
      width: 2.08rem;
      font-size: 0.24rem;
      color: rgba(255, 255, 255, 0.9);
      font-weight: 600;
      margin-top: 0.24rem;
    }

    .text-title {
      font-size: 0.3rem;
      font-weight: 600;
      color: rgba(255, 255, 255, 0.9);
      line-height: 120%;
      text-align: justify;
    }

    .text-content {
      font-size: 0.26rem;
      font-weight: 400;
      color: rgba(255, 255, 255, 0.9);
      line-height: 150%;
      margin-top: 0.16rem;
      text-align: justify;
    }

    &.text-right {
      padding: 0.2rem;
      background-color: #289afd;
      color: rgba(255, 255, 255, 1);
      border-top-right-radius: 0.1rem;

      .theme-ytPink& {
        background-color: #ff79b5;
        color: #fff;
        border-radius: 0.16rem;
      }
    }

    &.image-box {
      padding: 0;
      border: solid 1px rgba(0, 0, 0, 0.1);
      border-radius: 8px;

      .theme-white& {
        border: solid 1px transparent;
      }
    }

    &.video-box {
      padding: 0;
      position: relative;
      // border: solid 1px rgba(0, 0, 0, 0.1);
      border-radius: 8px;

      .theme-white& {
        border: solid 1px transparent;
      }

      .poster {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 9;
        background-color: rgba(0, 0, 0, 1);

        .theme-white& {
          border: solid 1px transparent;
        }
      }

      .play-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        max-width: 0.6rem;
        min-width: 0.2rem;
        width: 15%;
        z-index: 99;
      }
    }

    &.help {
      color: rgba(0, 0, 0, 0.5);

      &.can-click {
        color: rgba(53, 131, 255, 1);
      }
    }
  }

  &.left {
    .bubble {
      align-self: flex-start;
    }
  }

  &.right {
    .bubble {
      align-self: flex-end;
    }
  }

  .text-list {
    display: flex;
    flex-direction: column;
    font-size: 0.26rem;
    color: #6eafcc;
    width: @content-width;

    .question-box {
      background: #222;
      padding: 0.4rem 0.32rem;

      .theme-white& {
        border-radius: 0.16rem;
        background-color: #fff;
      }

      .question {
        // padding: 0 0.28rem;
        & > span {
          position: relative;
          display: block;
          // padding: 0.19rem 0;
          padding-bottom: 0.24rem;
          line-height: 0.4rem;
          // &::before {
          //   position: absolute;
          //   bottom: 0;
          //   content: ' ';
          //   width: 100%;
          //   height: 20px;
          //   // height: 0.44rem;
          //   // transform: scaleY(0.5);
          //   background-color: rgba(0, 0, 0, 0.1);
          // }
        }

        &:last-child > span {
          padding-bottom: 0;
          // &::before {
          //   position: absolute;
          //   bottom: 0;
          //   content: ' ';
          //   width: 100%;
          //   height: 0;
          // }
        }
      }
    }

    .help {
      color: rgba(0, 0, 0, 0.5);

      &.can-click {
        color: rgba(53, 131, 255, 1);
      }
    }
  }

  img {
    display: block;
  }

  video {
    display: block;
  }

  .time {
    display: flex;
    justify-content: center;
    margin-top: 0.60rem;
    margin-bottom: -0.08rem;
    color: #7f7f7f;
    font-size: 0.26rem;
  }
}
</style>
